export const NATIONALITY_MESSAGES = {
  NOT_FOUND: 'No nationality records were found',
};


// WEBPACK FOOTER //
// ./src/constants/nationalityMessages.js